export default function isBrowser(func) {
  return process.browser ? func : () => isBrowser(func);
}



// WEBPACK FOOTER //
// ./utilities/is-browser.js